/**
 * Big Win Class
 *
 * at the moment this does not work if you require
 * different thresholds for bonus buy
 * 
 * i was thinking you could set it up something like 
 * 
 * {
      level: this.LEVEL_2_WIN,
      previousTitle: this._level1WinTextContainer,
      nextTitle: this._level2WinTextContainer,
      threshold: {
          default: this.getLevel2WinThreshold(),
          bb: this.getLevel2BBWinThreshold(),
      }
 * 
 */

(function () {
  class BigWin extends PIXI.Container {
    constructor() {
      super();

      // Big win levels
      this.LEVEL_1_WIN = 1;
      this.LEVEL_2_WIN = 2;
      this.LEVEL_3_WIN = 3;
      this.LEVEL_4_WIN = 4;
      this.LEVEL_5_WIN = 5;
      this.LEVEL_6_WIN = 6;

      this._level1WinThreshold = 10;
      this._level2WinThreshold = 15;
      this._level3WinThreshold = 25;
      this._level4WinThreshold = 50;
      this._level5WinThreshold = 100;
      this._level6WinThreshold = 200;

      this._totalDuration = 8000; // the big win tune is 7.6 seconds long
      this._winType = this.LEVEL_1_WIN;

      this.isActive = false;
      this.skipWin = false;
      this.allowSkipWin = false;
      this.currentLevel = 0;
      this.currentTitle = null;

      this.winAmount = 0;
      this.callback = undefined;
      this.countUpPromise = null;
      this.bigWinPromise = null;
    }

    getWinType(amount, stake) {
      if (amount >= stake * this._level6WinThreshold) {
        return this.LEVEL_6_WIN;
      } else if (amount >= stake * this._level5WinThreshold) {
        return this.LEVEL_5_WIN;
      } else if (amount >= stake * this._level4WinThreshold) {
        return this.LEVEL_4_WIN;
      } else if (amount >= stake * this._level3WinThreshold) {
        return this.LEVEL_3_WIN;
      } else if (amount >= stake * this._level2WinThreshold) {
        return this.LEVEL_2_WIN;
      } else {
        return this.LEVEL_1_WIN;
      }
    }

    getLevel1WinThreshold() {
      return this._level1WinThreshold;
    }

    getLevel2WinThreshold() {
      return this._level2WinThreshold;
    }

    getLevel3WinThreshold() {
      return this._level3WinThreshold;
    }

    getLevel4WinThreshold() {
      return this._level4WinThreshold;
    }

    getLevel5WinThreshold() {
      return this._level5WinThreshold;
    }

    getLevel6WinThreshold() {
      return this._level6WinThreshold;
    }

    willTriggerBigWin(amount = 0, stake = gameController.globalHelperGetBaseStake()) {
      const threshold = stake * this._level1WinThreshold;
      return amount >= threshold;
    }

    init() {
      this._dimScreen = resourceManager.get('bigWinDimObject');
      this._dimScreen.show(false);

      this._bigWinContainer = resourceManager.getContainer('bigWinContainer');
      this._bigWinContainer.visible = false;

      // Value Text Backing
      this._winAwardTextBacking = resourceManager.get('bigWin:BigWin:awardTextBacking');
      this._winAwardTextBacking.visible = false;

      // NOTE: This uses a meter - you can't override the font size of the meter
      this._winAwardText = resourceManager.get('bigWin:BigWin:awardTextBacking:awardTextScaleContainer:awardText');
      this._winAwardText.visible = false;

      this._awardTextFinalPos = resourceManager.get('bigWin:BigWin:awardTextFinalPos');
      this._awardTextStartPos = resourceManager.get('bigWin:BigWin:awardTextStartPos');

      this._level1WinTextContainer = resourceManager.get('bigWin:BigWin:level1WinTextContainer');
      this._level1WinTextContainer.visible = false;

      this._level2WinTextContainer = resourceManager.get('bigWin:BigWin:level2WinTextContainer');
      this._level2WinTextContainer.visible = false;

      this._level3WinTextContainer = resourceManager.get('bigWin:BigWin:level3WinTextContainer');
      this._level3WinTextContainer.visible = false;

      this._level4WinTextContainer = resourceManager.get('bigWin:BigWin:level4WinTextContainer');
      this._level4WinTextContainer.visible = false;

      this._level5WinTextContainer = resourceManager.get('bigWin:BigWin:level5WinTextContainer');
      this._level5WinTextContainer.visible = false;

      this._level6WinTextContainer = resourceManager.get('bigWin:BigWin:level6WinTextContainer');
      this._level6WinTextContainer.visible = false;

      this.burst1 = resourceManager.get('bigWin:BigWin:BurstContainer:Burst1');
      this.burst1.visible = false;
      this.burst2 = resourceManager.get('bigWin:BigWin:BurstContainer:Burst2');
      this.burst2.visible = false;

      this._level2emitter = particleManager.createEmitter(
        'bigwin_level2_emitter',
        'bigWin:BigWin:particlesContainer',
        0,
        0,
        false
      );
      this._level2emitter.particleEmitter.emit = false;
      this._level2emitter.visible = false;

      this._level3Emitter = particleManager.createEmitter(
        'bigwin_level3_emitter',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._level3Emitter.particleEmitter.emit = false;
      this._level3Emitter.visible = false;

      this._level4Emitter = particleManager.createEmitter(
        'bigwin_level4_emitter',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._level4Emitter.particleEmitter.emit = false;
      this._level4Emitter.visible = false;

      this._level5Emitter = particleManager.createEmitter(
        'bigwin_level5_emitter',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._level5Emitter.particleEmitter.emit = false;
      this._level5Emitter.visible = false;

      this._level6Emitter = particleManager.createEmitter(
        'bigwin_level6_emitter',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._level6Emitter.particleEmitter.emit = false;
      this._level6Emitter.visible = false;

      this._skipBigWinBox = resourceManager.get('bigWin:BigWin:skipBigWinBox');
      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.visible = true;
      this._skipBigWinBox.interactive = false;
      this._skipBigWinBox.quad.buttonMode = false;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart = () => {
        this.skip();
      };

      this.presentLevelData = [
        {
          level: this.LEVEL_1_WIN,
          previousTitle: null,
          nextTitle: this._level1WinTextContainer,
          threshold: null,
          nextThreshold: null,
          emitterToStop: null,
          emitterToStart: null,
        },
        {
          level: this.LEVEL_2_WIN,
          previousTitle: this._level1WinTextContainer,
          nextTitle: this._level2WinTextContainer,
          threshold: this.getLevel2WinThreshold(),
          nextThreshold: this.getLevel3WinThreshold(),
          emitterToStop: null,
          emitterToStart: this._level2emitter,
        },
        {
          level: this.LEVEL_3_WIN,
          previousTitle: this._level2WinTextContainer,
          nextTitle: this._level3WinTextContainer,
          threshold: this.getLevel3WinThreshold(),
          nextThreshold: this.getLevel4WinThreshold(),
          emitterToStop: this._level2emitter,
          emitterToStart: this._level3Emitter,
        },
        {
          level: this.LEVEL_4_WIN,
          previousTitle: this._level3WinTextContainer,
          nextTitle: this._level4WinTextContainer,
          threshold: this.getLevel4WinThreshold(),
          nextThreshold: this.getLevel5WinThreshold(),
          emitterToStop: this._level3Emitter,
          emitterToStart: this._level4Emitter,
        },
        {
          level: this.LEVEL_5_WIN,
          previousTitle: this._level4WinTextContainer,
          nextTitle: this._level5WinTextContainer,
          threshold: this.getLevel5WinThreshold(),
          nextThreshold: this.getLevel6WinThreshold(),
          emitterToStop: this._level4Emitter,
          emitterToStart: this._level5Emitter,
        },
        {
          level: this.LEVEL_6_WIN,
          previousTitle: this._level5WinTextContainer,
          nextTitle: this._level6WinTextContainer,
          threshold: this.getLevel6WinThreshold(),
          nextThreshold: null,
          emitterToStop: this._level5Emitter,
          emitterToStart: this._level6Emitter,
        },
      ];
    }

    isBigWinActive() {
      return this.isActive;
    }

    validateOptions(options) {
      if (!Utils.isNumber(options.winAmount)) {
        options.winAmount = 0;
      }
      if (!Utils.isFunction(options.cbOnInitialDelayFinished)) {
        options.cbOnInitialDelayFinished = () => {};
      }
      if (!Utils.isFunction(options.cbOnPresentLevel)) {
        options.cbOnPresentLevel = () => {};
      }
      if (!Utils.isFunction(options.cbOnCountUpFinished)) {
        options.cbOnCountUpFinished = () => {};
      }
      if (!Utils.isFunction(options.cbOnOutroStart)) {
        options.cbOnOutroStart = () => {};
      }
      if (!Utils.isFunction(options.cbOnOutroFinished)) {
        options.cbOnOutroFinished = () => {};
      }
      if (!Utils.isFunction(options.cbWhenFinished)) {
        options.cbWhenFinished = () => {};
      }
      if (!Utils.isString(options.whereFrom)) {
        options.whereFrom = '';
      }
      if (!Utils.isNumber(options.delayInMS)) {
        options.delayInMS = 0;
      }
      if (!Utils.isNumber(options.stake)) {
        options.stake = gameController.globalHelperGetBaseStake();
      }
      if (!Utils.isBoolean(options.shortVersion)) {
        options.shortVersion = false;
      }
    }

    // because we have so many parameters i think its now best to be an object we pass in
    start(options) {
      if (options.shortVersion === true) {
        this.doBigWinShort(options);
      } else {
        this.doBigWin(options);
      }
    }

    getAmountToCountUp(nextThreshold, threshold) {
      let amountToCountUp = 0;

      if (nextThreshold === null && threshold === null) {
        // return 0
      } else if (nextThreshold === null) {
        // got to the highest stage
        amountToCountUp = this.winAmount - this._currentStake * threshold;
      } else {
        amountToCountUp = Math.min(this._currentStake * nextThreshold, this.winAmount) - this._currentStake * threshold;
      }
      return amountToCountUp;
    }

    getBigWinPromise() {
      return this.bigWinPromise;
    }

    // because we have so many parameters i think its now best to be an object we pass in
    async doBigWin(options) {
      this.validateOptions(options);
      this.whereFrom = options.whereFrom;
      this.isActive = true;

      if (options.delayInMS > 0) {
        await timerManager.delayAsync(options.delayInMS);
      }

      options.cbOnInitialDelayFinished();

      let doBigWinResolver = null;
      this.bigWinPromise = new Promise((resolve) => {
        doBigWinResolver = resolve;
      });

      this.winAmount = options.winAmount;
      this.skipWin = false;
      this.allowSkipWin = false;

      // lets dim the screen
      this._dimScreen.show(true);
      this._dimScreen.alpha = 0;
      gsap.to(this._dimScreen, {
        duration: 0.3,
        alpha: 0.6,
      });

      this._currentStake = options.stake;

      this._winType = this.getWinType(this.winAmount, this._currentStake);
      const duration = this._totalDuration / this._winType;
      this.visible = true;

      await this.intro();

      for (let i = 0; i < this.presentLevelData.length; i++) {
        const presentLevelData = this.presentLevelData[i];
        const { threshold, level, nextTitle } = presentLevelData;
        if (this.winAmount >= this._currentStake * threshold) {
          this.currentLevel = level;
          this.currentTitle = nextTitle;
          options.cbOnPresentLevel();
          await this.presentLevel(presentLevelData, duration);
        }
      }

      musicManager.stopBigWin();
      musicManager.playBigWinEnd();

      options.cbOnCountUpFinished();

      // disable the skip
      this._skipBigWinBox.interactive = false;
      this._skipBigWinBox.quad.buttonMode = false;
      this.allowSkipWin = false;

      await this.showFinalResult();

      options.cbOnOutroStart();

      await this.outro();

      options.cbOnOutroFinished();

      this.restoreTunesAfterBigWin();

      this.isActive = false;
      this.visible = false;

      options.cbWhenFinished();

      doBigWinResolver();
      this.bigWinPromise = null;
    }

    async doBigWinShort(options) {
      this.validateOptions(options);
      this.whereFrom = options.whereFrom;
      this.isActive = true;

      if (options.delayInMS > 0) {
        await timerManager.delayAsync(options.delayInMS);
      }

      options.cbOnInitialDelayFinished();

      let doBigWinResolver = null;
      this.bigWinPromise = new Promise((resolve) => {
        doBigWinResolver = resolve;
      });

      this.winAmount = options.winAmount;
      this.skipWin = false;
      this.allowSkipWin = false;

      // lets dim the screen
      this._dimScreen.show(true);
      this._dimScreen.alpha = 0;
      gsap.to(this._dimScreen, {
        duration: 0.3,
        alpha: 0.6,
      });

      this._currentStake = options.stake;

      this._winType = this.getWinType(this.winAmount, this._currentStake);
      const duration = this._totalDuration / this._winType;
      this.visible = true;

      await this.introShort();

      this.pulseTitle(this.currentTitle);

      await timerManager.delayAsync(1500);

      // musicManager.stopBigWin();
      // musicManager.playBigWinEnd();

      this._skipBigWinBox.interactive = false;
      this._skipBigWinBox.quad.buttonMode = false;
      this.allowSkipWin = false;

      options.cbOnOutroStart();

      this.restoreTunesAfterBigWin();

      await this.outro();

      options.cbOnOutroFinished();

      this.isActive = false;
      this.visible = false;

      options.cbWhenFinished();

      doBigWinResolver();
      this.bigWinPromise = null;
    }

    restoreTunesAfterBigWin() {
      if (this.whereFrom === 'freespinsEnd') {
        // TODO
        // the current flow handles the audio when leaving free spins
        // so when we know more about all that, we can restore this bit
        return;
      }

      let level = musicManager.SPINLEVEL;
      if (this.whereFrom === 'freespinsInter') {
        level = musicManager.FREESPINS_LEVEL1;
      } else if (this.whereFrom === 'freespinsEnd') {
        level = musicManager.FREESPINS_LEVEL1;
      } else {
        // const bgTrail = resourceManager.get('bgTrail:BGTrailContainer');
        // if (bgTrail.isFull() === true) {
        //   level = musicManager.SINGLEWINLEVEL;
        // }
      }
      musicManager.restoreTunesAfterBigWin(level);
    }

    canSkip() {
      return this.isActive && !this.skipWin && this.allowSkipWin;
    }

    degreesToRadians(degrees) {
      return degrees * (Math.PI / 180);
    }

    // not using the one from game, because we have listenForSkipWin
    // and i cant for the life of me work out how to make it generic for now
    async tweenFromToAsync(targets, fromVars, toVars, tweenInfo = null) {
      let resolver = null;
      const tweenPromise = new Promise((resolve) => {
        resolver = resolve;
      });

      const origOnComplete = toVars.onComplete;
      toVars.paused = true;
      if (toVars.listenForSkipWin === true) {
        const self = this;
        toVars.onUpdate = function () {
          if (self.skipWin) {
            this.progress(1);
          }
        };
      }
      toVars.listenForSkipWin = null;
      delete toVars.listenForSkipWin;
      toVars.onComplete = () => {
        if (origOnComplete) {
          origOnComplete();
        }
        resolver();
      };

      const tween = gsap.fromTo(targets, fromVars, toVars);
      tween.time(0).restart(true);

      if (tweenInfo) {
        tweenInfo.tween = tween;
        tweenInfo.resolver = resolver;
        tweenInfo.promise = tweenPromise;
      }

      return tweenPromise;
    }

    async scaleInBursts() {
      this.burst1.visible = true;
      this.burst2.visible = true;

      await Promise.all([
        this.tweenFromToAsync(
          this.burst1.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1.5,
            y: 1.5,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this.burst2.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1,
            y: 1,
            duration: 0.5,
          }
        ),
      ]);
    }

    async fadeInBursts() {
      await Promise.all([
        this.tweenFromToAsync(
          this.burst1,
          {
            alpha: 0,
          },
          {
            alpha: 0.6,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this.burst2,
          {
            alpha: 0,
          },
          {
            alpha: 0.5,
            duration: 0.5,
          }
        ),
      ]);
    }

    async scaleInTitle(title, listenForSkipWin = false) {
      title.alpha = 1;
      title.visible = true;
      await this.tweenFromToAsync(
        title.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          listenForSkipWin: listenForSkipWin,
          duration: 0.5,
        }
      );
    }

    async moveInWinAwardTextBacking() {
      this._winAwardTextBacking.scale.x = 1;
      this._winAwardTextBacking.scale.y = 1;
      this._winAwardTextBacking.visible = true;

      await Promise.all([
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            x: this._awardTextStartPos.position.getX(),
            y: this._awardTextStartPos.position.getY(),
          },
          {
            x: this._awardTextFinalPos.position.getX(),
            y: this._awardTextFinalPos.position.getY(),
            duration: 0.333,
          }
        ),
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.2,
          }
        ),
      ]);
    }

    async moveOutWinAwardTextBacking() {
      await Promise.all([
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            x: this._awardTextFinalPos.position.getX(),
            y: this._awardTextFinalPos.position.getY(),
          },
          {
            x: this._awardTextStartPos.position.getX(),
            y: this._awardTextStartPos.position.getY(),
            duration: 0.5,
          }
        ),
      ]);

      this._winAwardTextBacking.visible = false;
      this._winAwardText.set(0);
      this._winAwardText.visible = false;
    }

    startRotatingBursts() {
      // start the bursts rotating
      this.burst1.rotation = 0;
      this.burst2.rotation = 0;
      this.rotateBurst1Tween = gsap.to(this.burst1, {
        duration: 12,
        rotation: this.degreesToRadians(359),
        repeat: -1,
        ease: 'none',
      });
      this.rotateBurst2Tween = gsap.to(this.burst2, {
        duration: 12,
        rotation: this.degreesToRadians(-359),
        repeat: -1,
        ease: 'none',
      });
    }

    stopRotatingBursts() {
      if (this.rotateBurst1Tween) {
        this.rotateBurst1Tween.kill();
        this.rotateBurst1Tween = null;
      }
      if (this.rotateBurst2Tween) {
        this.rotateBurst2Tween.kill();
        this.rotateBurst2Tween = null;
      }
    }

    // Big win intro - this can't be skipped
    async intro() {
      musicManager.playBigWin(false);

      const firstLevelData = this.presentLevelData[0];

      // lets kick off the 1st emitter
      if (firstLevelData.emitterToStart) {
        firstLevelData.emitterToStart.particleEmitter.emit = true;
        firstLevelData.emitterToStart.visible = true;
      }

      // set the count up to show big win starting value and hide
      // dont use the nice win threshold, as nice win comes in straight away, use the big win, as this is when
      // the title switches and exits the presentLevel
      let amountToCountUp = Math.min(this._currentStake * this.getLevel2WinThreshold(), this.winAmount);

      this._winAwardText.set(0);
      this._winAwardText.visible = true;
      const duration = this._totalDuration / this._winType;
      this.countUpPromise = this.countUp(amountToCountUp, duration);

      this.startRotatingBursts();

      // make ourselves visible
      this._bigWinContainer.visible = true;

      this.previousTitle = null;
      this.currentTitle = firstLevelData.nextTitle;

      // lets start bringing stuff in
      const scaleInBurstsPromise = this.scaleInBursts();
      const fadeInBurstsPromise = this.fadeInBursts();
      const scaleInTitlePromise = this.scaleInTitle(this.currentTitle);
      const moveInWinAwardTextBackingPromise = this.moveInWinAwardTextBacking();

      // wait for all the intro tweens to finish
      await Promise.all([
        scaleInBurstsPromise,
        fadeInBurstsPromise,
        scaleInTitlePromise,
        moveInWinAwardTextBackingPromise,
      ]);
    }

    async introShort() {
      const firstLevelData = this.presentLevelData[this._winType - 1];

      // lets kick off the 1st emitter
      if (firstLevelData.emitterToStart) {
        firstLevelData.emitterToStart.particleEmitter.emit = true;
        firstLevelData.emitterToStart.visible = true;
      }

      this.startRotatingBursts();

      // make ourselves visible
      this._bigWinContainer.visible = true;

      this.previousTitle = null;
      this.currentTitle = firstLevelData.nextTitle;

      // lets start bringing stuff in
      const scaleInBurstsPromise = this.scaleInBursts();
      const fadeInBurstsPromise = this.fadeInBursts();
      const scaleInTitlePromise = this.scaleInTitle(this.currentTitle);

      // wait for all the intro tweens to finish
      await Promise.all([
        scaleInBurstsPromise, //
        fadeInBurstsPromise,
        scaleInTitlePromise,
      ]);

      musicManager.playBigWin(true);
    }

    async countUp(amountToCountUp, duration) {
      this.countUpResolver = null;
      const countUpPromise = new Promise((resolve) => {
        this.countUpResolver = resolve;
      });

      this._winAwardText.countUp(amountToCountUp, duration, () => {
        this.countUpResolver();
        this.countUpResolver = null;
      });

      await countUpPromise;
    }

    pulseTitle(title) {
      this.pulseTitleTween = gsap.fromTo(
        title.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingTitle() {
      this.pulseTitleTween.kill();
    }

    pulseWinAwardText() {
      this.pulseWinAwardTextTween = gsap.fromTo(
        this._winAwardText.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingWinAwardText() {
      this.pulseWinAwardTextTween.kill();
      this._winAwardText.scale.x = 1;
      this._winAwardText.scale.y = 1;
    }

    async scaleOutAndFadeOffTitle(title, listenForSkipWin = false) {
      await Promise.all([
        this.tweenFromToAsync(
          title.scale,
          {
            x: title.scale.x,
            y: title.scale.y,
          },
          {
            x: 3,
            y: 3,
            listenForSkipWin: listenForSkipWin,
            duration: 0.75,
          }
        ),
        this.tweenFromToAsync(
          title,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            listenForSkipWin: listenForSkipWin,
            duration: 0.5,
          }
        ),
      ]);
    }

    async presentLevel(levelData, duration) {
      const { previousTitle, nextTitle, threshold, nextThreshold, emitterToStop, emitterToStart } = levelData;

      if (previousTitle) {
        this.stopPulsingTitle();
        this.scaleOutAndFadeOffTitle(previousTitle, true);
      }

      if (emitterToStop) {
        emitterToStop.particleEmitter.emit = false;
      }
      if (emitterToStart) {
        emitterToStart.particleEmitter.emit = true;
        emitterToStart.visible = true;
      }

      this._winAwardText.visible = true;
      if (!this.countUpSound) {
        this.countUpSound = soundManager.play('winCountUp');
      }

      if (!this.skipWin) {
        if (this.countUpPromise === null) {
          const amountToCountUp = this.getAmountToCountUp(nextThreshold, threshold);
          this.countUpPromise = this.countUp(amountToCountUp, duration);
        } else {
          // already have a promise, this will be from the intro
        }
      }

      if (previousTitle && nextTitle) {
        if (!this.skipWin) {
          soundManager.play('bigwinUpgrade');
        }
        const scaleInTitlePromise = this.scaleInTitle(nextTitle, true);
        await scaleInTitlePromise;
      }

      if (nextTitle) {
        this.pulseTitle(nextTitle);
      }

      if (!this.skipWin) {
        this.allowSkipWin = true;
        this._skipBigWinBox.interactive = true;
        this._skipBigWinBox.quad.buttonMode = true;
      }

      // and then we need to wait for the count up to finish
      await this.countUpPromise;
      this.countUpPromise = null;
    }

    async showFinalResult() {
      soundManager.stop('winCountUp');
      this.countUpSound = null;
      soundManager.play('winCountUpEnd');
      this.pulseWinAwardText();
      await timerManager.delayAsync(1500);
      this.stopPulsingWinAwardText();
    }

    async fadeOut() {
      await Promise.all([
        this.tweenFromToAsync(
          this._bigWinContainer,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._dimScreen,
          {
            alpha: 0.6,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
      ]);

      this._bigWinContainer.visible = false;
      this._bigWinContainer.alpha = 1;
    }

    stopAllEmitters() {
      this._level6Emitter.particleEmitter.emit = false;
      this._level6Emitter.visible = false;

      this._level5Emitter.particleEmitter.emit = false;
      this._level5Emitter.visible = false;

      this._level4Emitter.particleEmitter.emit = false;
      this._level4Emitter.visible = false;

      this._level3Emitter.particleEmitter.emit = false;
      this._level3Emitter.visible = false;

      this._level2emitter.particleEmitter.emit = false;
      this._level2emitter.visible = false;
    }

    async outro() {
      // start fading everything out
      const fadeOutPromise = this.fadeOut();
      const scaleOutAndFadeOffTitlePromise = this.scaleOutAndFadeOffTitle(this.currentTitle);
      const moveOutWinAwardTextBackingPromise = this.moveOutWinAwardTextBacking();
      await Promise.all([
        fadeOutPromise, //
        scaleOutAndFadeOffTitlePromise,
        moveOutWinAwardTextBackingPromise,
      ]);

      // now we cant be seen
      // clean up stuff
      this.stopAllEmitters();
      this.stopRotatingBursts();
      this.burst1.visible = false;
      this.burst2.visible = false;
      this._dimScreen.show(false);
    }

    skip() {
      if (this.canSkip()) {
        this._skipBigWinBox.interactive = false;
        this._skipBigWinBox.quad.buttonMode = false;
        this.allowSkipWin = false;
        this._winAwardText.cancelCountUp();
        this._winAwardText.set(this.winAmount);
        musicManager.stopBigWin();
        this.skipWin = true;
      }
    }
  }

  var creator = function (json) {
    return new BigWin();
  };

  var initialise = function (json, obj) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('BigWin', creator, initialise, filesRequired);
})();
